// Constants
import { TMX_IFRAME_ID } from './constants/wait-for-tmx-profile.utils.constants';
// Enumerations
import { TmxProfileResultEnumeration } from './enumerations/tmx-profile-result.enumeration';
// Types
import { WaitForTmxProfileUtilType } from './types/wait-for-tmx-profile.utils.type';

const waitForTmxProfile = ({
  timeoutMs,
}: WaitForTmxProfileUtilType): Promise<TmxProfileResultEnumeration> =>
  new Promise<TmxProfileResultEnumeration>(
    (resolve: (result: TmxProfileResultEnumeration) => void): void => {
      let isResolved = false;
      let observer: MutationObserver | null = null;
      let timeoutHandle: ReturnType<typeof setTimeout> | null = null;

      const cleanup = (): void => {
        if (observer) {
          observer.disconnect();
          observer = null;
        }
        if (timeoutHandle !== null) {
          clearTimeout(timeoutHandle);
          timeoutHandle = null;
        }
      };

      const resolveOnce = (result: TmxProfileResultEnumeration): void => {
        if (!isResolved) {
          isResolved = true;
          cleanup();
          resolve(result);
        }
      };

      const handleIframeLoadEvent = (): void => {
        resolveOnce(TmxProfileResultEnumeration.COMPLETED);
      };

      const attachIframeLoadListener = (iframe: HTMLIFrameElement): void => {
        iframe.addEventListener('load', handleIframeLoadEvent, { once: true });
      };

      const existingIframe = document.getElementById(TMX_IFRAME_ID);
      if (existingIframe instanceof HTMLIFrameElement) {
        attachIframeLoadListener(existingIframe);
      }

      observer = new MutationObserver((): void => {
        const iframe = document.getElementById(TMX_IFRAME_ID);
        if (iframe instanceof HTMLIFrameElement) {
          attachIframeLoadListener(iframe);
        }
      });
      observer.observe(document.body, { childList: true, subtree: true });

      timeoutHandle = setTimeout((): void => {
        resolveOnce(TmxProfileResultEnumeration.TIMEOUT);
      }, timeoutMs);
    }
  );

export { waitForTmxProfile };
